module.exports = __webpack_public_path__ + "static/MS-02bec589f351fcd307b8b02e1ecfda16.jpg";